import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import apiClient from '../api/axios';
import './LoginPage/LoginPage.css'; // ログインページと似たスタイルを再利用

const ResetPasswordPage: React.FC = () => {
    const [searchParams] = useSearchParams();

    const [token, setToken] = useState<string | null>(null);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const tokenFromUrl = searchParams.get('token');
        if (tokenFromUrl) {
            setToken(tokenFromUrl);
        } else {
            setError('無効なページです。トークンが見つかりません。');
        }
    }, [searchParams]);

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const toggleShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!password || !confirmPassword) {
            setError('新しいパスワードと確認用パスワードの両方を入力してください。');
            return;
        }

        if (password !== confirmPassword) {
            setError('パスワードが一致しません。');
            return;
        }

        if (!token) {
            setError('トークンが無効です。再度パスワードリセットを要求してください。');
            return;
        }

        setIsLoading(true);
        try {
            await apiClient.post('/api/auth/reset-password', {
                token: token,
                new_password: password,
            });
            setSuccess('パスワードが正常に更新されました。ログインページに戻ってログインしてください。');
        } catch (err: any) {
            const detail = err.response?.data?.detail || 'パスワードの更新に失敗しました。トークンが無効か、有効期限が切れている可能性があります。';
            setError(detail);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-page-container">
            <div className="login-form-container">
                <h2>パスワード再設定</h2>
                
                {success ? (
                    <div className="success-message">
                        <p>{success}</p>
                        <Link to="/login" className="login-button" style={{ textDecoration: 'none', display: 'block', textAlign: 'center' }}>
                            ログインページへ
                        </Link>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="new-password">新しいパスワード</label>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    id="new-password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={toggleShowPassword}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        color: '#888',
                                    }}
                                    className="password-toggle-button"
                                >
                                    {showPassword ? '非表示' : '表示'}
                                </button>
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="confirm-password">新しいパスワード（確認用）</label>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    id="confirm-password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={toggleShowConfirmPassword}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        color: '#888',
                                    }}
                                    className="password-toggle-button"
                                >
                                    {showConfirmPassword ? '非表示' : '表示'}
                                </button>
                            </div>
                        </div>
                        {error && <p className="error-message">{error}</p>}
                        <button type="submit" className="login-button" disabled={isLoading || !token}>
                            {isLoading ? '更新中...' : 'パスワードを更新'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ResetPasswordPage;
